import { Injectable } from '@angular/core';
import { AsyncSubject, Observable, Subject, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FilterResponse, VenueIdentifier } from 'src/app/2d-maps-editor/shared/models/venue-identifier.interface';
@Injectable({
  providedIn: 'root',
})
export class ClientContentDistributionService {
  private currentCDClient: any;
  private currentCDClient$: AsyncSubject<any> = new AsyncSubject();
  private apiRoot = '/api/private/';

  constructor(private http: HttpClient) { }

  public getAsyncCDClient$(): Observable<any> {
    return this.currentCDClient$.asObservable();
  }
  public setAsyncCDClient(data: any): void {
    this.currentCDClient = data;
    this.currentCDClient$.next(this.currentCDClient);
    this.currentCDClient$.complete();
  }
  public getCurrentCDClient() {
    return this.currentCDClient;
  }

  public getCDClientVenues(page?) {
    let queryparams = '';
    if (page) {
      queryparams = '?page=' + page;
    }
    return this.http.get<any>(environment.contentdistribution.private.url + `${this.apiRoot}client/venues` + queryparams);
  }

  public filter(codes: string[]): Observable<VenueIdentifier[]> {
    let queryParams = '?fields=code,key&venuerelated=regions';
    const body = {
      venues: [],
    };
    codes.forEach(code => body.venues.push({ code: code }));
    return this.http
      .post<any>(environment.contentdistribution.private.url + `${this.apiRoot}client/venues/filter` + queryParams, body)
      .pipe(map((response: FilterResponse) => response.venues));
  }

  public postCDClientVenuesFind(field, value) {
    let queryparams = '';
    if (field === 'code' && value) {
      queryparams = '?' + field + '=' + value;
    }
    let body = {};
    if (field === 'key') {
      body = { key: value };
    }
    return this.http.post<any>(
      environment.contentdistribution.private.url + `${this.apiRoot}client/venues/search` + queryparams,
      body
    );
  }
}
